import { DropTargetLocations, dropTargetOrientation, dropTypes } from '../constants/dnd';
import { layoutNodeTypes } from '../constants/dndAreaHoverPositionConstants';
import { getDropTargetPositionAndBounds } from './dropTargetUtils';
const createMoveSectionBeforeDropTarget = (dropTarget, nodePositionsById) => {
  const {
    orientation,
    targetedSectionId,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[targetedSectionId];
  return {
    dropTargetLocationType: DropTargetLocations.BEFORE,
    top: currentContainerPosition.top,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    dropType: type,
    orientation
  };
};
const createMoveSectionAfterDropTarget = (dropTarget, nodePositionsById) => {
  const {
    orientation,
    targetedSectionId,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[targetedSectionId];
  return {
    dropTargetLocationType: DropTargetLocations.AFTER,
    top: currentContainerPosition.bottom,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    dropType: type,
    orientation
  };
};
const createInsertElementBeforeDropTarget = (dropTarget, nodePositionsById) => {
  const {
    previousSiblingId,
    containerId,
    targetedElementId,
    type
  } = dropTarget;
  const prevSiblingPosition = previousSiblingId && nodePositionsById[previousSiblingId];
  const currentContainerPosition = nodePositionsById[containerId];
  const targetedElementPosition = nodePositionsById[targetedElementId];
  const {
    type: layoutNodeType
  } = currentContainerPosition;
  if (layoutNodeType === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK) {
    const midpointBetweenElements = prevSiblingPosition ? (prevSiblingPosition.right + targetedElementPosition.left) / 2 : targetedElementPosition.left;
    return {
      dropTargetLocationType: DropTargetLocations.BEFORE,
      dropType: type,
      top: currentContainerPosition.top,
      left: midpointBetweenElements,
      height: currentContainerPosition.height,
      orientation: dropTargetOrientation.VERTICAL
    };
  }
  const midpointBetweenElements = prevSiblingPosition ? (prevSiblingPosition.bottom + targetedElementPosition.top) / 2 : targetedElementPosition.top;
  return {
    dropTargetLocationType: DropTargetLocations.BEFORE,
    dropType: type,
    top: midpointBetweenElements,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    orientation: dropTargetOrientation.HORIZONTAL
  };
};
const createInsertElementAfterDropTarget = (dropTarget, nodePositionsById) => {
  const {
    nextSiblingId,
    containerId,
    targetedElementId,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  const targetedElementPosition = nodePositionsById[targetedElementId];
  const nextSiblingPosition = nextSiblingId && nodePositionsById[nextSiblingId];
  const {
    type: layoutNodeType
  } = currentContainerPosition;
  if (layoutNodeType === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK) {
    const midpointBetweenElements = nextSiblingPosition ? (targetedElementPosition.right + nextSiblingPosition.left) / 2 : targetedElementPosition.right;
    return {
      dropTargetLocationType: DropTargetLocations.AFTER,
      dropType: type,
      top: currentContainerPosition.top,
      height: currentContainerPosition.height,
      left: midpointBetweenElements,
      orientation: dropTargetOrientation.VERTICAL
    };
  }
  const midpointBetweenElements = nextSiblingPosition ? (nextSiblingPosition.top + targetedElementPosition.bottom) / 2 : targetedElementPosition.bottom;
  return {
    dropTargetLocationType: DropTargetLocations.AFTER,
    dropType: type,
    top: midpointBetweenElements,
    width: currentContainerPosition.width,
    left: currentContainerPosition.left,
    orientation: dropTargetOrientation.HORIZONTAL
  };
};
const createInsertIntoTableCellDropTarget = (dropTarget, nodePositionsById) => {
  const {
    orientation,
    targetedCellId,
    type
  } = dropTarget;
  const targetedCellPosition = nodePositionsById[targetedCellId];
  return {
    dropTargetLocationType: DropTargetLocations.INSIDE,
    dropType: type,
    top: targetedCellPosition.top,
    left: targetedCellPosition.left,
    width: targetedCellPosition.width,
    height: targetedCellPosition.height,
    orientation
  };
};
const createAppendGridCellDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    lastChildId,
    type
  } = dropTarget;
  const gridTablePosition = nodePositionsById[containerId];
  const lastChildPosition = nodePositionsById[lastChildId];
  if (lastChildPosition) {
    return {
      dropTargetLocationType: DropTargetLocations.AFTER,
      dropType: type,
      top: lastChildPosition.top,
      left: lastChildPosition.right,
      width: lastChildPosition.width,
      height: lastChildPosition.height,
      orientation: dropTargetOrientation.VERTICAL
    };
  } else if (gridTablePosition) {
    return {
      dropTargetLocationType: DropTargetLocations.INSIDE,
      dropType: type,
      top: gridTablePosition.top,
      left: gridTablePosition.left,
      width: gridTablePosition.width,
      height: gridTablePosition.height,
      orientation: dropTargetOrientation.VERTICAL
    };
  }
  return null;
};
const createInsertAfterTableCellDropTarget = (dropTarget, nodePositionsById) => {
  const {
    nextSiblingId,
    targetedCellId,
    type
  } = dropTarget;
  const targetedCellPosition = nodePositionsById[targetedCellId];
  const nextSiblingPosition = nodePositionsById[nextSiblingId];
  return {
    dropTargetLocationType: DropTargetLocations.AFTER,
    dropType: type,
    top: targetedCellPosition.top,
    left: nextSiblingPosition ? (targetedCellPosition.right + nextSiblingPosition.left) / 2 : targetedCellPosition.right,
    width: targetedCellPosition.width,
    height: targetedCellPosition.height,
    orientation: dropTargetOrientation.VERTICAL
  };
};
const createInsertIntoEmptyStackDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    orientation,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  if (orientation === dropTargetOrientation.HORIZONTAL) {
    return {
      dropTargetLocationType: DropTargetLocations.INSIDE,
      dropType: type,
      top: currentContainerPosition.top,
      left: currentContainerPosition.left,
      width: currentContainerPosition.width,
      orientation
    };
  }
  return {
    dropTargetLocationType: DropTargetLocations.INSIDE,
    dropType: type,
    top: currentContainerPosition.top,
    left: currentContainerPosition.left,
    height: currentContainerPosition.height,
    orientation
  };
};
const createWrapAndInsertAboveContainerDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    orientation,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  return {
    dropTargetLocationType: DropTargetLocations.BEFORE,
    dropType: type,
    top: currentContainerPosition.top,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    height: currentContainerPosition.height,
    orientation
  };
};
const createWrapAndInsertBelowContainerDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    orientation,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  return {
    dropTargetLocationType: DropTargetLocations.AFTER,
    dropType: type,
    top: currentContainerPosition.bottom,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    height: currentContainerPosition.height,
    orientation
  };
};
const createWrapAndInsertLeftOfContainerDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    orientation,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  return {
    dropTargetLocationType: DropTargetLocations.BEFORE,
    dropType: type,
    top: currentContainerPosition.top,
    left: currentContainerPosition.left,
    width: currentContainerPosition.width,
    height: currentContainerPosition.height,
    orientation
  };
};
const createWrapAndInsertRightOfContainerDropTarget = (dropTarget, nodePositionsById) => {
  const {
    containerId,
    orientation,
    type
  } = dropTarget;
  const currentContainerPosition = nodePositionsById[containerId];
  return {
    dropTargetLocationType: DropTargetLocations.AFTER,
    dropType: type,
    top: currentContainerPosition.top,
    left: currentContainerPosition.right,
    width: currentContainerPosition.width,
    height: currentContainerPosition.height,
    orientation
  };
};
const createInsertIntoEmptyGridLayoutDropTarget = (dropTarget, nodePositionsById) => {
  const {
    gridLayoutId,
    orientation,
    type
  } = dropTarget;
  const gridLayoutPosition = nodePositionsById[gridLayoutId];
  return {
    dropTargetLocationType: DropTargetLocations.INSIDE,
    dropType: type,
    top: gridLayoutPosition.top,
    left: gridLayoutPosition.right,
    width: gridLayoutPosition.width,
    height: gridLayoutPosition.height,
    orientation
  };
};
const createOnPegboardDropTarget = (dropTarget, nodePositionsById) => {
  const {
    row,
    column: dropTargetColumnStart,
    containerId,
    dragElementId,
    type
  } = dropTarget;
  const pegboardNodePosition = nodePositionsById[containerId];
  const dragItemNodePosition = nodePositionsById[dragElementId];
  if (!dragItemNodePosition || pegboardNodePosition.type !== layoutNodeTypes.PEGBOARD || dragItemNodePosition.type !== layoutNodeTypes.GRID_LAYOUT_MODULE) {
    return null;
  }
  const {
    top,
    left,
    width,
    height
  } = getDropTargetPositionAndBounds({
    targetRow: row,
    targetColumn: dropTargetColumnStart,
    dragItemNodePosition,
    pegboardNodePosition
  });
  return {
    dropTargetLocationType: DropTargetLocations.INSIDE,
    dropType: type,
    top,
    left,
    width,
    height,
    orientation: dropTarget.orientation
  };
};
const createCenterOnPegboardDropTarget = (dropTarget, nodePositionsById) => {
  const {
    row,
    column: dropTargetColumnStart,
    containerId,
    dragElementId,
    type
  } = dropTarget;
  const pegboardNodePosition = nodePositionsById[containerId];
  const dragItemNodePosition = nodePositionsById[dragElementId];
  if (!dragItemNodePosition || pegboardNodePosition.type !== layoutNodeTypes.PEGBOARD || dragItemNodePosition.type !== layoutNodeTypes.GRID_LAYOUT_MODULE) {
    return null;
  }
  const {
    top,
    left,
    width,
    height
  } = getDropTargetPositionAndBounds({
    targetRow: row,
    targetColumn: dropTargetColumnStart,
    dragItemNodePosition: Object.assign({}, dragItemNodePosition, {
      columnsSpanned: dropTarget.columnsSpanned
    }),
    pegboardNodePosition
  });
  return {
    dropTargetLocationType: DropTargetLocations.INSIDE,
    dropType: type,
    top,
    left,
    width,
    height,
    orientation: dropTarget.orientation
  };
};
const DROP_TARGET_POS_INFO_HANDLERS = {
  [dropTypes.MOVE_SECTION_BEFORE]: createMoveSectionBeforeDropTarget,
  [dropTypes.MOVE_SECTION_AFTER]: createMoveSectionAfterDropTarget,
  [dropTypes.INSERT_ELEMENT_BEFORE]: createInsertElementBeforeDropTarget,
  [dropTypes.INSERT_ELEMENT_AFTER]: createInsertElementAfterDropTarget,
  [dropTypes.INSERT_INTO_TABLE_CELL]: createInsertIntoTableCellDropTarget,
  [dropTypes.APPEND_GRID_CELL]: createAppendGridCellDropTarget,
  [dropTypes.INSERT_AFTER_TABLE_CELL]: createInsertAfterTableCellDropTarget,
  [dropTypes.INSERT_INTO_EMPTY_STACK]: createInsertIntoEmptyStackDropTarget,
  [dropTypes.WRAP_AND_INSERT_ABOVE_CONTAINER]: createWrapAndInsertAboveContainerDropTarget,
  [dropTypes.WRAP_AND_INSERT_BELOW_CONTAINER]: createWrapAndInsertBelowContainerDropTarget,
  [dropTypes.WRAP_AND_INSERT_LEFT_OF_CONTAINER]: createWrapAndInsertLeftOfContainerDropTarget,
  [dropTypes.WRAP_AND_INSERT_RIGHT_OF_CONTAINER]: createWrapAndInsertRightOfContainerDropTarget,
  [dropTypes.INSERT_INTO_EMPTY_GRID_LAYOUT]: createInsertIntoEmptyGridLayoutDropTarget,
  [dropTypes.ON_PEGBOARD]: createOnPegboardDropTarget,
  [dropTypes.CENTER_ON_PEGBOARD]: createCenterOnPegboardDropTarget
};
const getDropTargetHandler = dropType => {
  return DROP_TARGET_POS_INFO_HANDLERS[dropType];
};
export const getDropTargetInfo = (dropTarget, nodePositionsById) => {
  const {
    type
  } = dropTarget;
  const handler = getDropTargetHandler(type);
  const dropTargetPosInfo = handler(dropTarget, nodePositionsById);
  if (!dropTargetPosInfo) {
    console.error(`No drop target info for drop type ${type}`);
    return null;
  }
  return dropTargetPosInfo;
};